import React from 'react';
import '../../styles/Footer.css';
import { Link } from 'react-router-dom';
import FacebookIcon from '../../assets/ic_facebook.svg';
import LinkedInIcon from '../../assets/ic_linkedin.svg';
import InstagramIcon from '../../assets/ic_instagram.svg';
import Label from '../atoms/Label';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Logo Section */}
        <div className="footer-logo">
          <a href="/">
            <img src="/path-to-your-logo.png" alt="Brand Logo" />
          </a>
        </div>

      <div className='footer-nav-office-container'>
        {/* Navigation Links */}
        <div className="footer-nav">
          <a href="/">Home</a>
          <a href="/exam">Exam</a>
          <a href="/blog">Blog</a>
        </div>

        {/* Office Locations */}
        <div className="footer-office">
          <h3>Our Office</h3>
          <div className="office-locations">
            <div className="location">
              <div className="label-container">
                <Label label="GREER" fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
                <Label label="South Carolina, 29650," fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
                <Label label="United States" fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
              </div>
            </div>
            <div className="location">
              <div className="label-container">
                <Label label="CHALOTTE" fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
                <Label label="Waxhaw, 28173," fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
                <Label label="United States" fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="left"/>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="social-section">
        <div className="social-content">
          <Label label="Follow us on" fontSize={"16px"} color={"#FFFFFF"} fontWeight={"400"} textAlign="center"/>
          <div className="social-icons">
            <img src={FacebookIcon} alt="Facebook" /> 
            <img src={LinkedInIcon} alt="LinkedIn" />
            <img src={InstagramIcon} alt="Instagram" />
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="copyright">
        <p>© 2025 Brand Name All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;